// extracted by mini-css-extract-plugin
module.exports = {"root":"WkNPA","item":"z2MxW","marquee":"tpiDe","text-large":"ZHoD1"};